import { render, staticRenderFns } from "./ExpedienteEntryResolucion.vue?vue&type=template&id=d425cbac&scoped=true&"
import script from "./ExpedienteEntryResolucion.vue?vue&type=script&lang=js&"
export * from "./ExpedienteEntryResolucion.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteEntryResolucion.vue?vue&type=style&index=0&id=d425cbac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d425cbac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VCardText,
  VDataTable,
  VDivider,
  VFlex,
  VLayout,
  VTextField,
})
